import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent implements OnInit {

  @Input() isChecked: boolean;
  @Input() isDisabled: boolean;
  @Input() fieldName: string;
  @Input() enabledValue = 'on';
  // Accessible name for the switch. Must be a STRING, not an IDREF: ion-toggle's
  // inheritAriaAttributes() strips every aria-* off the host, and its render then
  // re-applies only aria-label -- aria-describedby is hardcoded to the internal
  // hint-text id, so an IDREF into our light DOM is silently discarded.
  // (@ionic/core 8.7.7, components/toggle/toggle.js:170,245.)
  @Input() ariaLabel: string;
  @Output() onChange: EventEmitter<string> = new EventEmitter();

  private value: string;

  constructor() {
  }

  @Input() getValue: () => string = () => this.value;

  ngOnInit() {
    this.value = this.isChecked ? this.enabledValue : '';
  }

  public onToggle(event: Event | any): void {
    this.value = event.target.checked ? this.enabledValue : '';
    this.onChange.emit(this.value);
  }

}
